import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { SectionTitle } from "./ui";
import { waLink } from "@/lib/site";

const ITEMS = [
  ["cambio", "Quiero cambiarme de Isapre"],
  ["alza", "Me llegó un aviso de alza"],
  ["fonasa", "Vengo de Fonasa"],
  ["familia", "Mi familia está creciendo"],
  ["revisar", "Tengo Isapre y quiero revisar mi plan"],
];

export const Situations = () => (
  <section id="situaciones" data-testid="situations-section" className="bg-[#F4F7F9] py-16 sm:py-24">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16">
      <Reveal>
        <SectionTitle title="Qué situaciones atendemos" intro="Toca la que se parece a la tuya y conversemos por WhatsApp." />
        <img src="/img/consulta.webp" alt="Papá con su hijo pequeño conversando con una doctora en la consulta" loading="lazy"
          className="aspect-[3/2] w-full rounded-2xl object-cover object-[center_40%]" />
      </Reveal>
      <ul className="flex flex-col gap-3 lg:justify-center">
        {ITEMS.map(([id, t], i) => (
          <Reveal key={id} delay={i * 0.05}>
            <li>
              <a href={waLink(`Hola, ${t.charAt(0).toLowerCase() + t.slice(1)} y quiero asesorarme.`)} target="_blank" rel="noopener noreferrer"
                data-testid={`situation-${id}`}
                className="group flex min-h-[72px] items-center justify-between gap-4 rounded-2xl border border-[#E3EAEF] bg-white px-6 py-4 text-[19px] font-semibold text-[#1F2A33] transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-[#1FA89A] focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-[#0B3C5D]">
                {t}
                <ArrowRight className="h-6 w-6 shrink-0 text-[#13766C] transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </a>
            </li>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
